export default __webpack_public_path__ + "locales/el-GR/UploadPanel.json?hash=448429670dfc0df332633e7d20f14d0a";